import { SET_PROFILES, UPDATE_PROFILE, DELETE_PROFILE } from './types';

const initialState = {
    data: [],
    loading: false,
    error: null
};

const profilesReducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_PROFILES:
            return {
                ...state,
                data: action.payload
            };
        case UPDATE_PROFILE:
            return {
                ...state,
                data: state.data.map(profile =>
                    profile.id === action.payload.id ? action.payload : profile
                )
            };
        case DELETE_PROFILE:
            return {
                ...state,
                data: state.data.filter(profile => profile.id !== action.payload)
            };
        default:
            return state;
    }
};

export default profilesReducer; 